import React, {useEffect, useState} from "react";
import BraftEditor, {BraftEditorProps, MediaType} from "braft-editor";
import 'braft-editor/dist/index.css'
import * as minio from "../../utils/minio";
import *  as utils from "../../utils/utils";


interface EditorProps extends BraftEditorProps {
    uploadPrefix?: string
    upload?: (path: string) => Promise<any>
}

function Editor(props: EditorProps) {
    const {uploadPrefix, upload, value, onChange, ...otherProps} = props

    useEffect(() => {
        if (typeof (value) === 'string') {
            onChange?.(BraftEditor.createEditorState(value))
        }
    }, [value])

    const media: MediaType = {
        accepts: {
            image: 'image/png,image/jpeg,image/gif,image/webp,image/apng,image/svg',
            video: 'video/mp4',
            audio: false
        },
        uploadFn: params => {
            const file = params.file
            const path = `${uploadPrefix}/${utils.generateFileName('media', file.name)}`
            minio.upload(file, path).then(() => {
                return upload && upload(path)
            }).then(() => {
                params.success({
                    url: minio.getUrl(path),
                    meta: {
                        id: path,
                        title: path,
                        alt: path,
                        loop: false,
                        autoPlay: false,
                        controls: false,
                        poster: '',
                    }
                })
            }).catch(() => {
                params.error({msg: '上传失败'})
            })
        }
    }

    return (
        <BraftEditor {...otherProps} media={media}
                     onChange={onChange}
                     value={value}/>
    )
}

export default Editor
